// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

// Components
import "./components";

// Plugins
import "./plugins";

// Sync router with store
import { sync } from "vuex-router-sync";

// Application imports
import App from "./App";
import i18n from "@/i18n";
import router from "@/router";
import store from "@/store";
import VueClipboard from "vue-clipboard2";
import Storage from "vue-ls";
import VueLodash from "vue-lodash";
import Meta from "vue-meta";
import VueAnalytics from "vue-analytics";
import VueGtm from "vue-gtm";
import Hotjar from "vue-hotjar";
import VueTidio from "vue-tidio";

import { createProvider } from "./vue-apollo";
import vuetify from "./plugins/vuetify";
const VueCookie = require("vue-cookie");

// Lodash
Vue.use(VueLodash);

// Add Moment Library
const moment = require("moment");
//require('moment/locale/en')

Vue.use(require("vue-moment"), {
  moment,
});

// Sync store with router
sync(store, router);

Vue.config.productionTip = false;
Vue.use(VueCookie);

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

// LocalStorage plugin
Vue.use(Storage, {
  namespace: "aivia_app_", // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local", // storage name session, local, memory
});

Vue.use(Meta);

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.VUE_APP_GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== "development",
    },
  });
}

// Bootstrap Hotjar
// Set in .env
// https://github.com/henk-badenhorst/vue-hotjar
if (process.env.VUE_APP_HOTJAR) {
  Vue.use(Hotjar, {
    id: process.env.VUE_APP_HOTJAR, // Hotjar Site ID
    isProduction: process.env.NODE_ENV !== "development",
  });
}

if (process.env.VUE_APP_GTM) {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GTM,
    enabled: process.env.NODE_ENV !== "development", // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  });
}

// Bootstrap Tidio
// Set in .env
// https://github.com/nikolasp/vue-tidio
if (process.env.VUE_APP_TIDIO) {
  Vue.use(VueTidio, {
    appKey: process.env.VUE_APP_TIDIO,
  });
}

/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  apolloProvider: createProvider(),
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
